import Vue from 'vue'
import App from './App.vue'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/global.css';
import axios from "axios";
import VueRouter from "vue-router";
import router from "./router";
import 'element-ui/lib/theme-chalk/index.css'
import {Upload} from 'element-ui'
import JsonExcel from 'vue-json-excel'
Vue.component('downloadExcel', JsonExcel)
// import DownloadExcel from './components/DownloadExcel.vue';
// Vue.component('download-excel', DownloadExcel);

Vue.prototype.$axios=axios;

Vue.prototype.$httpUrl='https://aimatch.chat/api/';

// http://localhost:8081
// https://aimatch.chat/api/
//
Vue.config.productionTip = false
Vue.use(Upload)
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(ElementUI, {size:'small'});
new Vue({
  router,
  components: { App },
  template: '<App/>',
  render: h => h(App),
}).$mount('#app')
